module.exports = __webpack_public_path__ + "media/images/gallery/1-54e7f6b2520597658cde4aae3537c671.jpg";